import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { ApplicantForm } from '../../forms/applicant.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../openapi';

@Component({
  selector: 'app-institution-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective
  ],
  templateUrl: './institution-form.component.html'
})
export class InstitutionFormComponent implements OnInit {

  private applicantType = '13d02d24-9e22-46f8-80ce-5d641fa8aeaa';

  @Input()
  public form: ApplicantForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  constructor() {
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.applicantType });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.applicantType });
  }

  public ngOnInit(): void {
    this.form?.applicantType.setValue(this.applicantType);

    this.form?.name.enable();
    this.form?.nip.enable();

    this.form?.firstName.disable();
    this.form?.lastName.disable();
  }
}
